var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusDeferred = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.66667V8.83333L10.2083 10.9333L10.85 9.86667L7.91667 8.125V4.66667H6.66667ZM15 6.33333V0.5L12.8 2.7C11.45 1.34167 9.575 0.5 7.5 0.5C3.35833 0.5 0 3.85833 0 8C0 12.1417 3.35833 15.5 7.5 15.5C11.6417 15.5 15 12.1417 15 8H13.3333C13.3333 11.2167 10.7167 13.8333 7.5 13.8333C4.28333 13.8333 1.66667 11.2167 1.66667 8C1.66667 4.78333 4.28333 2.16667 7.5 2.16667C9.10833 2.16667 10.5667 2.825 11.625 3.875L9.16667 6.33333H15Z",
    fill: "#7D7D7D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusDeferred);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_status_deferred.e8bc131a57183bac2ec2f15b05324352.svg";